import { LocalDatasheetTabDto } from "../components/editor/types/tab-dto";
import { DatasheetElement, DatasheetElementId } from "../types/datasheet-element";

const COPIED_TAB_STORAGE_KEY = "progeny_copied_datasheet_tab";
const COPIED_TAB_ELEMENTS_STORAGE_KEY = "progeny_copied_datasheet_tab_elements";

export type CopiedTabData = {
  tab: LocalDatasheetTabDto;
  elements: Record<DatasheetElementId, DatasheetElement>;
};

/**
 * Save copied tab data to sessionStorage for cross-datasheet copy/paste
 */
export const saveCopiedTabToStorage = (tab: LocalDatasheetTabDto, elements: Record<DatasheetElementId, DatasheetElement>): void => {
  try {
    sessionStorage.setItem(COPIED_TAB_STORAGE_KEY, JSON.stringify(tab));
    sessionStorage.setItem(COPIED_TAB_ELEMENTS_STORAGE_KEY, JSON.stringify(elements));
  } catch (error) {
    console.error("Failed to save copied tab to sessionStorage:", error);
  }
};

/**
 * Load copied tab data from sessionStorage
 */
export const loadCopiedTabFromStorage = (): CopiedTabData | null => {
  try {
    const tabJson = sessionStorage.getItem(COPIED_TAB_STORAGE_KEY);
    const elementsJson = sessionStorage.getItem(COPIED_TAB_ELEMENTS_STORAGE_KEY);
    
    if (!tabJson || !elementsJson) {
      return null;
    }
    
    const tab = JSON.parse(tabJson) as LocalDatasheetTabDto;
    const elements = JSON.parse(elementsJson) as Record<DatasheetElementId, DatasheetElement>;
    
    return { tab, elements };
  } catch (error) {
    console.error("Failed to load copied tab from sessionStorage:", error);
    return null;
  }
};

/**
 * Check if there's a copied tab in sessionStorage
 */
export const hasCopiedTabInStorage = (): boolean => {
  try {
    return sessionStorage.getItem(COPIED_TAB_STORAGE_KEY) !== null;
  } catch (error) {
    console.error("Failed to check copied tab in sessionStorage:", error);
    return false;
  }
};

/**
 * Clear copied tab data from sessionStorage
 */
export const clearCopiedTabFromStorage = (): void => {
  try {
    sessionStorage.removeItem(COPIED_TAB_STORAGE_KEY);
    sessionStorage.removeItem(COPIED_TAB_ELEMENTS_STORAGE_KEY);
  } catch (error) {
    console.error("Failed to clear copied tab from sessionStorage:", error);
  }
};
